<template>
  <v-app>
    <!-- Drawer -->
    <NavigationDrawer v-if="user" v-model="drawer" />
    <!-- AppBar -->
    <AppBar v-if="user" @toggle-drawer="drawer = !drawer" />
    <!-- Main Content -->
    <v-main app :class="user ? 'page-wrapper-main' : 'page-wrapper'">
      <v-container fluid>
        <alert-component />
        <router-view />
      </v-container>
    </v-main>
    <app-footer />
  </v-app>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AppBar from './components/AppBar.vue';
import AppFooter from './components/AppFooter.vue';
import AlertComponent from '@/components/system/AlertComponent.vue';
import NavigationDrawer from './components/NavigationDrawer.vue';

export default {
  components: { AppBar, AppFooter, AlertComponent, NavigationDrawer },
  data() {
    return {
      drawer: true,
    };
  },
  async mounted() {
    await this.fetchUser();

  },
  methods: {
    ...mapActions('authen', ['fetchUser']),


    async initializeUser() {


    },

  },
  computed: {
    ...mapState('authen', ['user']),
  },
  watch: {
    user(newUser) {
      if (newUser) this.initializeUser(newUser);
    },
  },
};
</script>

<style>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.page-wrapper-main,
.page-wrapper {
  background-color: #f5f5f9;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.page-wrapper {
  padding-left: 0px !important;
}

.content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

html, body, #app {
  background-color: #f5f5f9 !important;
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>